import dayjs from 'dayjs'

const US_FORMAT = 'YYYY-MM-DD'
const BR_FORMAT = 'DD/MM/YYYY'

export const toEN = (date?: string): string => (date ? dayjs(date).format(US_FORMAT) : '')

export const toYear = (date?: any): number | null => (date ? dayjs(date).year() : null)

export const toBR = (date?: string | null): string => (date ? dayjs(date).format(BR_FORMAT) : '')

export const fromBR = (date: string): string =>
  date && date ? dayjs(date, BR_FORMAT).format(US_FORMAT) : ''

export const isBefore = (dateBefore: any, dateAfter?: any): boolean => {
  const today = dayjs()
  const validDateBefore = dayjs(dateBefore)
  const validDateAfter = dayjs(dateAfter)

  let isValid = false

  if (validDateBefore.isAfter(today) || validDateAfter.isAfter(today)) {
    isValid = false
  } else if (validDateBefore.isAfter(validDateAfter)) {
    isValid = false
  } else {
    isValid = true
  }

  return isValid
}

export const calculateAge = (dateOfBirth: string): number | null => {
  const birthDate = dayjs(dateOfBirth)
  const today = dayjs()
  return today.diff(birthDate, 'year') || null
}
